import React from "react";
import { Formik, Field, Form, FieldArray } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import SearchSelect from "utils/SearchSelect";
import MultySearchSelect from "utils/MultySearchSelect";
import extractValues from "utils/extractValues";
import initItem from "utils/initItem";
import { cleanArray } from "utils/editHelper";
// components

const types = [
  { label: "لیگ", value: "League" },
  { label: "تیم", value: "Team" },
  { label: "بازی", value: "Match" },
  { label: "بازیکن", value: "Player" },
];

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  const config = {
    match: {
      valueField: "id",
      labelFields: [
        "homeTeam.translations.fa.name",
        "awayTeam.translations.fa.name",
      ],
    },
    league: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    team: {
      valueField: "id",
      labelFields: ["translations.fa.name"],
    },
    player: {
      valueField: "id",
      labelFields: ["translations.fa.name", "translations.fa.lastName"],
    },
  };
  const updatedItem = initItem(item, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const clean = cleanObject(values, [
              "id",
              "uuid",
              "updatedAt",
              "createdAt",
              "metaData",
            ]);

            const keysToRemove = ["id", "updatedAt", "createdAt"];

            const statistics = cleanArray(values.statistics, keysToRemove);
            clean.statistics = statistics;

            const result = extractValues(clean, [
              "player",
              "league",
              "team",
              "match",
            ]);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <div className="intro-y">
                    <Field
                      label="نوع آمار :"
                      name="type"
                      component={Select}
                      options={types}
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="لیگ :"
                      name="league"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="league"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="تیم :"
                      name="team"
                      component={SearchSelect}
                      searchFields="translations.name"
                      collectionName="team"
                      showFields="translations.name"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label=" بازی:"
                      name="match"
                      component={SearchSelect}
                      searchFields="homeTeam.translations.name,awayTeam.translations.name"
                      collectionName="match"
                      showFields="homeTeam.translations.name,awayTeam.translations.name,matchDate"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>

                  <div className="intro-y">
                    <Field
                      label="بازیکن :"
                      name="player"
                      component={SearchSelect}
                      searchFields="translations.name,translations.lastName"
                      collectionName="player"
                      showFields="translations.name,translations.lastName"
                      className="w-full px-3 py-2 border rounded"
                    />
                  </div>
                </div>

                <div className="intro-x mt-10">
                  <FieldArray name="statistics">
                    {({ push, remove }) => (
                      <div>
                        <div className="flex items-center justify-between mb-6">
                          <h4 className="font-bold text-lg mb-4">آمار</h4>
                          <button
                            type="button"
                            onClick={() =>
                              push({
                                faKey: "",
                                enKey: "",
                                value: "",
                              })
                            }
                            className="mb-4 px-4 py-2 bg-green-500 text-white rounded shadow hover:bg-green-600"
                          >
                            افزودن آمار
                          </button>
                        </div>

                        {/* Iterate over statistics */}
                        {values?.statistics?.map((stat, index) => (
                          <div
                            key={index}
                            className="mb-6 border p-4 rounded shadow"
                          >
                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                کلید فارسی:
                              </label>
                              <Field
                                name={`statistics[${index}].faKey`}
                                type="text"
                                placeholder="کلید فارسی"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                کلید انگلیسی:
                              </label>
                              <Field
                                name={`statistics[${index}].enKey`}
                                type="text"
                                placeholder="کلید انگلیسی"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <div className="mb-4">
                              <label className="block text-gray-700 text-sm font-bold mb-2">
                                مقادیر:
                              </label>
                              <Field
                                name={`statistics[${index}].value`}
                                type="text"
                                placeholder="مقادیر"
                                className="w-full px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>

                            <button
                              type="button"
                              onClick={() => remove(index)}
                              className="px-3 py-2 bg-red-500 text-white rounded shadow hover:bg-red-600"
                            >
                              حذف آمار
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </FieldArray>
                </div>
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
